<template>
    <v-stepper v-model="e1">
        <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">
                Datos Producto
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">
                Stock Producto
            </v-stepper-step>

            <v-divider></v-divider>

        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content step="1">
                <v-card class="mb-12" color="grey lighten-1" height="400px">
                    <FormCrear @setdata="setProducto" ref="formCrear" :dataitem="dataitem"></FormCrear>
                </v-card>
                
                
                <v-btn class="mt-5" color="primary" @click="crearProducto()">
                    Continuar
                </v-btn>

                <v-btn class="mt-5" @click="$router.go(-1)"  text>
                    Cancel
                </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card class="mb-12" color="grey lighten-1" height="350px">
                    <CrearEditarExistencia  :data="producto" ref="existencias"></CrearEditarExistencia>
                </v-card>

                <v-btn class="mt-5"  color="primary" @click="crearExistencias()">
                    Guardar
                </v-btn>

                <v-btn class="mt-5"  text @click="$router.go(-1)">
                    Cancel
                </v-btn>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import FormCrear from '../CrearEditar.vue'
import CrearEditarExistencia from '../CrearEditarExistencia.vue'


  export default {
    components:{FormCrear,CrearEditarExistencia},
    data () {
      return {
        dataitem:{},
        e1: 1,
        producto:{
            establecimiento:{idestablecimiento:1   },
            articulo:{}
        }
      }
    },
    methods:{
       async crearProducto(){
           await this.$refs.formCrear.save()
                   
            this.e1 = 2
        },
       async crearExistencias(){
        
        await this.$refs.existencias.postItem()
        this.$router.go(-1)
       } ,
        async setProducto(data){
            await this.$store.dispatch('setProductos')  
            this.producto.articulo = data
            
        }
    }
  }
</script>